import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Send } from "lucide-react";
import { useThreads } from "@/hooks/useThreads";
import { useToast } from "@/hooks/use-toast";

interface NewThreadFormProps {
  onBack: () => void;
  onCreated: (threadId?: string) => void;
}

export default function NewThreadForm({ onBack, onCreated }: NewThreadFormProps) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { createThread } = useThreads();
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!title.trim()) {
      toast({
        title: "Blad",
        description: "Tytul jest wymagany",
        variant: "destructive",
      });
      return;
    }

    setSubmitting(true);

    const { error } = await createThread(title.trim(), content.trim());

    if (error) {
      toast({
        title: "Blad",
        description: error,
        variant: "destructive",
      });
    } else {
      toast({ title: "Pomysl dodany" });
      onCreated();
    }

    setSubmitting(false);
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={onBack}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <CardTitle className="text-lg">Nowy pomysl</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="thread-title">Tytul</Label>
            <Input
              id="thread-title"
              placeholder="Jaki masz pomysl na rozwoj panelu?"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              autoFocus
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="thread-content">Tresc (opcjonalnie)</Label>
            <Textarea
              id="thread-content"
              placeholder="Opisz szczegoly..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="min-h-[120px]"
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onBack}>
              Anuluj
            </Button>
            <Button type="submit" disabled={submitting || !title.trim()}>
              <Send className="h-4 w-4 mr-1" />
              {submitting ? "Dodawanie..." : "Dodaj pomysl"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
